module.exports = __webpack_public_path__ + "img/twit.11f4976c.svg";